import { Component, Output, Input, EventEmitter, Injectable, AfterViewInit } from '@angular/core';
import { MultiSelectorEventData } from 'src/app/models/multiSelectorProduct';
import { ProductOption } from 'src/app/models/productOption';

@Component({
    selector: 'upsell-multi-selector',
    templateUrl: 'upsell-multi-selector.html',
    styleUrls: ['upsell-multi-selector.scss'],
    standalone: false
})
export class UpsellMultiSelectorComponent implements AfterViewInit {
  @Input() productBoxTitle: string = 'Important information about our dog treats:';
  @Input() productBoxSubTitle: string = 'I want to show you a special opportunity to get the most out of our treat flavors - and SAVE BIG at the same time.';
  @Input() productBoxOptionTitle: string = 'Choose your flavor';
  @Input() imageAlt: string = '';
  @Input() currency: string = 'USD';

  // Product selection properties
  selectedProduct: ProductOption | null = null;
  @Output() pickedProduct: EventEmitter<MultiSelectorEventData> = new EventEmitter();

  // Product options data
  @Input() productOptions: ProductOption[] = [];

  constructor() {

  }

  ngAfterViewInit(): void {
    if (Array.isArray(this.productOptions) && this.productOptions.length > 0) {
      this.selectedProduct = this.productOptions[0]; // Default to the first product option
      this.selectProduct(this.selectedProduct); // Emit the default selected product
    } else {
      this.selectedProduct = null; // No product options available
      // Optionally, handle the empty case (e.g., show a warning or skip emitting)
    }
  }

  selectProduct(product: ProductOption): void {
    this.selectedProduct = product;
    this.pickedProduct.emit({
      sfid: this.selectedProduct.sfid,
      shippingCost: this.selectedProduct.shippingCost,
      offerPrice: this.selectedProduct.offerPrice,
      name: this.selectedProduct.name,
      regularPrice: this.selectedProduct.regularPrice,
      img: this.selectedProduct.img,
      displayName: this.selectedProduct.displayName,
      productTaxCode: this.selectedProduct.productTaxCode,
      description: `${this.selectedProduct.quantity} ${this.selectedProduct.unit}`
    });
  }
}
